import React from "react";
import Context from "../../../../../Context";
import { Modal } from "react-bootstrap";
import Blocker from "../../../../Misc/Blocker";
import InputForm from "../../../../Misc/InputForm";
import { Link } from "react-router-dom";

export default class WorkflowTypes extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      activeItem: false,
      add: false,
      edit: false,
      items: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    if (this.props.activeItem) {
      this.setState({ pending: true });
      let items = await this.context.api.qo("/workflow/type/list", {
        search: [
          { field: "class", compare: "EQL", value: this.props.activeItem },
        ],
      });

      this.setState({ pending: false, items });
    }
  };

  save = async (data) => {
    let activeItem = this.state.items[this.state.activeItem];
    if (this.state.edit) data.id = activeItem["id"];
    data.class = this.props.activeItem;

    this.setState({ pending: true });
    let result = await this.context.api.q("/workflow/type/set", data);
    if (result !== false) {
      this.context.toast("Тип сохранен", "success");
      this.load();
      this.setState({ edit: false, add: false });
    } else {
      this.context.toast("Не удалось сохранить тип", "error");
    }
    this.setState({ pending: false });
  };

  deleteClick = (item = {}) => {
    this.context
      .ask(
        `Вы действительно хотите удалить тип ${item.name} ${item.description}`,
        "Удаление типа",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete(item);
        }
      });
  };

  delete = async (item = {}) => {
    this.setState({ pending: true });

    let result = await this.context.api.q("/workflow/type/delete", {
      id: item.id,
    });
    if (result !== false) {
      this.context.toast(`${item.name}: Тип удален`, "success");
      this.load();
    } else {
      this.context.toast(`${item.name}: Не удалось удалить тип`, "error");
    }

    this.setState({ pending: false });
  };

  renderItems() {
    return (
      <>
        {Object.entries(this.state.items).map(([id, item]) => (
          <tr key={id}>
            <td width="20%">
              <span className="text-muted font-size-sm">{item.code} </span>
            </td>
            <td width="25%">{item.name}</td>
            <td width="55%">{item.description}</td>
            <td className="text-right text-nowrap">
              <button
                onClick={() => this.setState({ edit: true, activeItem: id })}
                className={`btn btn-light p-2 mr-2`}
              >
                <span className="flaticon2-edit px-2 align-middle"></span>
              </button>
              <Link
                title="Схемы согласования"
                to={`/scheme/${id}`}
                className={`btn btn-light p-2 mr-2`}
              >
                <span className="fa fa-sitemap px-2 align-middle"></span>
              </Link>
              <button
                onClick={() => this.deleteClick(item)}
                className={"btn btn-light p-2 text-hover-danger"}
              >
                <span className="flaticon2-rubbish-bin px-2 align-middle"></span>
              </button>
            </td>
          </tr>
        ))}
      </>
    );
  }
  render() {
    let activeItem = this.state.items[this.state.activeItem];
    return (
      <>
        <div>
          <Blocker on={this.state.pending}>
            {this.props.activeItem &&
            Object.keys(this.state.items).length > 0 ? (
              <table className="table w-100">
                <thead>
                  <tr>
                    <td>Код</td>
                    <td>Наименование</td>
                    <td>Описание</td>
                  </tr>
                </thead>
                <tbody>{this.renderItems()}</tbody>
              </table>
            ) : null}
            {this.props.activeItem ? (
              <button
                className="btn btn-light"
                onClick={() => this.setState({ add: true, activeItem: false })}
              >
                Добавить тип
              </button>
            ) : null}
          </Blocker>
          {this.state.add || this.state.edit ? (
            <Modal
              show={true}
              onHide={() => this.setState({ add: false, edit: false })}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {this.state.edit
                    ? this.state.items[this.state.activeItem]["name"]
                    : "Создать класс"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Blocker on={this.state.pending}>
                  <InputForm
                    fields={{
                      code: {
                        title: "Код",
                        type: "text",
                        validate: true,
                        error: false,
                        default: "",
                        col: "12",
                      },
                      name: {
                        title: "Наименование",
                        type: "text",
                        validate: true,
                        error: false,
                        default: "",
                        col: "12",
                      },
                      description: {
                        title: "Описание",
                        type: "text",
                        validate: false,
                        error: false,
                        default: "",
                        col: "12",
                      },
                    }}
                    data={activeItem}
                    key={this.state.add ? "add" : activeItem["id"]}
                    onSubmit={this.save}
                    onCancell={() => this.setState({ add: false, edit: false })}
                  />
                </Blocker>
              </Modal.Body>
            </Modal>
          ) : null}
        </div>
      </>
    );
  }
}
